import { LANGUAGES, Language } from "types/locale";

export const getStoredLanguage = (): Language => {
  const storedLanguage = localStorage.getItem("lang");
  return LANGUAGES.find((language) => language === storedLanguage) ?? Language.Lt;
};
